<template>
  <div class="app container">
    <div class="content">
      <search></search>
      <h2 class="messages" v-show="showIntro">Search a movie you liked and I'll tell you what you could watch next!</h2>
      <h2 class="messages" v-show="showErrorQuery">No movies found with this name :(</h2>
      <movies class="margin-top" :data="searchedMovies"></movies>
      <h2 class="label" v-show="recommendedMovies.movies.length > 0">You should like these movies</h2>
      <movies :data="recommendedMovies"></movies>
      <h2 class="label" v-show="recommendedMovies.movies.length > 0"><button @click="getMoreMovies">Show more</button></h2>
      <movieDetails>test</movieDetails>
    </div>
    <ItemFooter></ItemFooter>
  </div>
</template>

<script>
import Search from './components/Search';
import Movies from './components/Movies';
import Movie from './components/Movie';
import MovieDetails from './components/MovieDetails';
import ItemFooter from './components/ItemFooter';
import * as types from './component-types';

export default {
  name: 'app',
  components: {
    ItemFooter,
    Search,
    Movies,
    Movie,
    MovieDetails,
  },
  computed: {
    searchedMovies() {
      return {
        type: types.SEARCHED_MOVIE,
        movies: this.$store.getters.searchedMovies,
      };
    },
    recommendedMovies() {
      return {
        type: types.RECOMMENDED_MOVIE,
        movies: this.$store.getters.recommendedMovies,
      };
    },
    showIntro() {
      return this.$store.getters.getStatusIntro;
    },
    showErrorQuery() {
      return this.$store.getters.queryFailed;
    },
    showMovieDetails() {
      return this.$store.getters.getStatusMovieDetails;
    },
  },
  methods: {
    getMoreMovies() {
      this.$store.dispatch('increaseRequestedMovies');
    },
  },
  mounted() {
    this.$store.dispatch('getGenres');
  },
};
</script>

<style lang="scss">
  @import "style/libs/normalize";
  @import "style/libs/bootstrap-grid";

  html, body {
    // position: relative;
    height: 100%;
    margin: 0;
    padding: 0;
    background-color: #EDEDED;
    color: $font-color;
    font-size: 14px;
    -webkit-font-smoothing: antialiased !important;
    -webkit-tap-highlight-color: transparent !important;
    font-family: $font-family;
    letter-spacing: 0.02em;
    line-height: 1.15;
  }

  textarea, input, button {
    font-family: $font-family;
    outline: none;
    letter-spacing: 0;
  }

  button {
    text-transform: uppercase;
    margin: 0;
    border: none;
    cursor: pointer;
    transition: all 0.1s ease-in;
    padding: 4px;
    border-radius: 2px;
    font-weight: 700;
    background-color: transparent;
  }
</style>

<style lang="scss" scoped>
  .app {
    min-height: calc(100% - 72px);
    display: flex;
    flex-direction: column;
  }

  .content {
    flex: 1;
    // position: relative;
  }

  h2.label {
    font-size: 1.2em;
    margin: 20px auto;
    color: $primary-color;
    text-align: center;
    font-weight: 700;
    text-transform: uppercase;
  }

  h2.messages {
    width: 50%;
    margin: 100px auto auto;
    align-items: center;
    color: $light-font-color;
    font-weight: 500;
    text-align: center;
  }

  .margin-top {
    margin-top: 20px;
  }

  button {
    color: $primary-color;
    background-color: transparent;

     @media (min-width: $md) {
      &:hover {
        background-color: $dark-gray;
      }
    }

    &:active {
      background-color: $dark-gray;
    }
  }
</style>
